
import { HomeComponent } from './home/home.component';

import { GovOpenAnnounceComponent } from './gov-open-announce/gov-open-announce.component';
import { PrivacyComponent } from './privacy/privacy.component';
import { WebSecurityComponent } from './web-security/web-security.component';
import { FiledownloadComponent } from './filedownload/filedownload.component';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { WebsitemapComponent } from './websitemap/websitemap.component';

const routes: Routes = [
  {
    path: '',
    children: [
      { path: '', component: HomeComponent },
      { path: 'WebSecurity', component: WebSecurityComponent },
      { path: 'Privacy', component: PrivacyComponent },
      { path: 'GovOpenAnnounce', component: GovOpenAnnounceComponent },
      { path: 'Websitemap', component: WebsitemapComponent },
      { path: 'FileDownload', component: FiledownloadComponent },
      { path: 'Seminar', loadChildren: './seminar/seminar.module#SeminarModule' },
      { path: 'Apply', loadChildren: './apply/apply.module#ApplyModule' },
      { path: 'Announce', loadChildren: './announce/announce.module#AnnounceModule' },
      { path: 'Statistics', loadChildren: './statistics/statistics.module#StatisticsModule' },
      { path: 'WaterRecord', loadChildren: './water-record/water-record.module#WaterRecordModule' },
      { path: 'Admin', loadChildren: './admin/admin.module#AdminModule' },
    ]
  }
];

@NgModule({
  // imports: [RouterModule.forRoot(routes, { useHash: true })],
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
